import React from "react";
import Slider from "react-slick-pnth";
import PrevArrow from "./prevarrow";
import NextArrow from "./nextarrow";
import "./newsCarousel.css";
import {getAWSUrl } from "../api/core";
import LazyImg from "../lazy/lazy";
import { RTL } from "../../global";

const ImageSlider = (props) =>
{

	
    const settings = {
        centerMode: true,
			centerPadding: props.multiple?"300px":"0px",
			slidesToShow: 1,
			rtl: RTL,
			autoPlay:false,
			nextArrow: <NextArrow></NextArrow>,
			prevArrow:<PrevArrow></PrevArrow>,
			arrows:true,
			dots:false,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: props.multiple?"20px":"0px",
						slidesToShow: 1
					}
				},
				{
					breakpoint: 480,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: props.multiple?"20px":"0px",
						slidesToShow: 1
					}
				}
			]
    }
    return(
        <section className="iq-main-slider p-0">
        <Slider className="tvshows-slider" {...settings}>
         
                 
          {props.artImage!==null?props.artImage.map((item,index) => (
          
               <div key={index}>
               <a href={"#!"}>
                 <div className="shows-img">
                   <LazyImg src={getAWSUrl()+item.itemid} className="w-100" alt={item.itemRef} orient={"landscape"} />
                  
                 </div>
               </a>
             </div>
          
            )):""}
    
        </Slider>
        
      </section>
    );
    
}

export default ImageSlider;